
import React from 'react';
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import FormSectionHeader from './FormSectionHeader';

interface ContactInfoFieldsProps {
  formData: {
    website: string;
    contact_email: string;
  };
  setFormData: React.Dispatch<React.SetStateAction<any>>;
}

const ContactInfoFields: React.FC<ContactInfoFieldsProps> = ({ 
  formData, 
  setFormData 
}) => {
  return (
    <div className="space-y-4">
      <FormSectionHeader 
        title="Contact Information" 
        description="How potential investors can reach you" 
      />
      
      <div>
        <Label htmlFor="website">Website URL</Label>
        <Input
          id="website"
          type="url"
          placeholder="https://example.com"
          value={formData.website || ''}
          onChange={(e) => setFormData(prev => ({ ...prev, website: e.target.value }))}
        />
      </div>
      
      <div>
        <Label htmlFor="contact_email">Contact Email</Label>
        <Input
          id="contact_email"
          type="email"
          placeholder="contact@example.com"
          value={formData.contact_email || ''}
          onChange={(e) => setFormData(prev => ({ ...prev, contact_email: e.target.value }))}
        />
      </div>
    </div>
  );
};

export default ContactInfoFields;
